module.exports = __webpack_public_path__ + "img/EDM.34f1503d.png";